export default "__VITE_ASSET__CHjNimBv__"